import { GetEmbeddingCollectionExportUrl } from "@/APIURL"
import { UrlSaveToFileAsync } from "@/Helpers/SaveToFile"
import { Button } from "@mantine/core"
import { notifications } from "@mantine/notifications"
import { useState } from "react"

export function EmbeddingCollectionExportButton(props: { workspaceId: string, embeddingCollectionId: string, }) {
    const [loading, setLoading] = useState(false)
    return <>
        <Button loading={loading} onClick={() => {
            setLoading(true)
            try {
                UrlSaveToFileAsync(GetEmbeddingCollectionExportUrl(props.workspaceId, props.embeddingCollectionId), `${props.embeddingCollectionId}.zip`)
            } catch (e) {
                notifications.show({ message: "匯出失敗", color: "red" })
            }
            setLoading(false)
        }}>
            匯出
        </Button>
    </>
}